import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import { overlayStyle } from '../../styles/common-styles';
import './card.scss'

export default class Card extends React.Component {
  render() {
    const { url, title, excerpt, image } = this.props
    const standfirst = excerpt.split(' ').slice(0, 9).join(' ');

    return (
      <Link className="card" to={url}>
          <div className="card__preview">
            <figure className="card__preview-image">
              <div className="card__overlay" style={overlayStyle}/>
              <img className="card__image" src={image} alt={title + " image"} />
            </figure>
          </div>
          <div className="card__wrapper">
            <div className="card__content">
              <div className="card__inner-content">
                <h2 className="card__title">{title}</h2>
              </div>
              <div className="card__standfirst">{standfirst}...</div>
              <div className="card__metadata-container"></div>
            </div>
          </div>
      </Link>
    )
  }
}

Card.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  excerpt: PropTypes.string,
  created: PropTypes.string,
  image: PropTypes.string,
  author: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/card/card.js